import axios from 'axios'
export default {
    install(Vue, options) {
        Vue.prototype.$http=axios
        Vue.prototype.baseUrl=window.config.BASE_API
        Vue.prototype.AJAXPOSTJSON = 0 //使用POST json
        Vue.prototype.AJAXPUTJSON = 2 //使用PUT json
        Vue.prototype.AJAXPUTPARAM = 1 //使用传参
        Vue.prototype.apptoken = ""
        let Base64 = require('js-base64').Base64
        let cipherCode = true; //组件传参加密开关结合encode和gotoPage函数使用
        //示例：
        //let param = this.encode({key: value});
        //this.goToPage("地址名",加密后生成新对象);
        //解密方法转成对象
        //this.decode(this.$route.query);
        Vue.prototype.encode = function(Obj){
            //编码
            if(cipherCode){
                let enObj = JSON.stringify(Obj)
                //定义cipher为数据key，结合解码自定义修改此key
                return {cipher:Base64.encode(enObj)};
            }
            return Obj;
        }
        Vue.prototype.decode = function(Obj){
            //解码
            if(cipherCode){
                //判断自定义的key是否存在
                if(!this.empty(Obj.cipher)){
                    //使用定义cipher的key，获取数据可结合编码修改此key
                    Obj = Base64.decode(Obj.cipher)
                    let deObj = JSON.parse(Obj)
                    return deObj
                }else{
                    return '';
                }
            }
            return Obj;
        }
        Vue.prototype.matching=function(rep,str){
            /**正则配是否存在 */
            var reg = RegExp(rep,"g");
            return reg.test(str)
        }
        Vue.prototype.empty = function(obj){
            /**判断是否为空 */
            //console.log(null instanceof Object)
            var flag = false
            if (typeof(obj) =="string"){
                if(obj==''){
                    flag = true
                }else if(obj=='null'){
                    flag = true
                }
            }else if (typeof(obj) =="number"){
                if(obj==0){
                    flag = false
               }
            }else if (typeof(obj) =="boolean"){
                    flag = obj
            }else if (typeof(obj) =="undefined"){
                flag = true
            }else if(typeof(obj) =="object"){
                if(obj instanceof Array){
                    if(obj.length==0){
                        flag = true
                    }
                }else if(obj instanceof Object){
                    if(Object.keys(obj).length==0){
                        flag = true
                    }
                }else if(obj==null){
                    flag = true
                }
            }
            return flag
        }
        Vue.prototype.goToPage = function(name,params,flag){
            if(this.empty(params)){
                params = {}
            }
            if(this.empty(flag)){
                flag = "none"
            }
            switch(flag){
                case 'post':
                    this.$router.push({name: name,params:params});
                break
                case 'get':
                    this.$router.push({name: name,query:params});
                break
                default:
                    this.$router.push({name: name,query:params});
            }
        }
        Vue.prototype.openWindow = function(url){
            window.open(url, '_blank')
        }
        //AJAX GET
        Vue.prototype.ajaxGet = function(url,data,vueObjFun){
            var regexFind = new RegExp("^http");
            if(!regexFind.test(url)){
                url = this.baseUrl + url
            }
            var vueObj = this
            this.$http.get(url,data)  //发出请求
            .then(function(response){
                vueObjFun(response.data);
            }).catch(function(error){
                vueObjFun({code:-1,msg:"请求失败:"+error,data:[]});
            });
        }
        //ajax Post
        Vue.prototype.ajaxPost = function(url,data,vueObjFun,flag,param){
            var regexFind = new RegExp("^http");
            if(!regexFind.test(url)){
                url = this.baseUrl + url
            }
            this.apptoken = JSON.parse(sessionStorage.getItem("userInfo")) ? JSON.parse(sessionStorage.getItem("userInfo"))['access_token'] : '';
            //flag = 0
            switch(flag){
                case this.AJAXPOSTJSON:
                    this.ajaxPostJson(url,data,vueObjFun,param,"POST")
                    break
                case this.AJAXPUTJSON:
                    this.ajaxPostJson(url,data,vueObjFun,param,"PUT")
                    break
                case this.AJAXPUTPARAM:
                    this.ajaxPostUrlencoded(url,data,vueObjFun,param)
                    break
                default: this.ajaxPostUrlencoded(url,data,vueObjFun,param)
            }
        }
        //AJAX POST urlencoded
        Vue.prototype.ajaxPostUrlencoded = function(url,data,vueObjFun,param){
            var vueObj = this
            var regexFind = new RegExp("^http");
            if(!regexFind.test(url)){
                url = this.baseUrl + url
            }
            this.$http({
                method:'POST',
                url:url,
                data:data,
                transformRequest: [function (res) {
                let ret = ''
                for (let it in res) {
                    ret += encodeURIComponent(it) + '=' + encodeURIComponent(res[it]) + '&'
                }
                return ret
                }],
                headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': "Bearer "+this.apptoken
                }
            }).then(function (response) {
                if(!vueObj.empty(param)){
                    vueObjFun(response.data,param);
                }else{
                    vueObjFun(response.data);
                }
            }).catch(function (error) {
                vueObjFun({code:-1,msg:"请求失败:"+error,data:[]});
                console.log(error)
            });
        },
        //AJAX POST JSON
        Vue.prototype.ajaxPostJson = function(url,data,vueObjFun,param,method){
            var regexFind = new RegExp("^http");
            if(!regexFind.test(url)){
                url = this.baseUrl + url
            }
            var vueObj = this
            this.$http({
                method:method,
                url:url,
                data:data,
                headers: {
                'Content-Type': 'application/json',
                'Authorization': "Bearer "+ this.apptoken
                }
            }).then(function (response) {
                if(!vueObj.empty(param)){
                    vueObjFun(response.data,param);
                }else{
                    vueObjFun(response.data);
                }
            }).catch(function (error) {
                vueObjFun({code:-1,msg:"请求失败:"+error,data:[]});
                console.log(error)
            });
            
        }
    }
}


// WEBPACK FOOTER //
// ./src/utils/index.js